var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"element-box p-0"},[_c('div',{staticClass:"element-content p-3"},[_c('h6',{staticClass:"element-header capitalize"},[_vm._v("\n\t\t\t"+_vm._s(_vm.t.create_user)+"\n\t\t")]),_vm._v(" "),(_vm.userForm)?_c('symForm',{attrs:{"options":_vm.opt,"data":_vm.formData,"form":_vm.userForm,"formProcess":_vm.formProcess},on:{"sended":_vm.getUserForm}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54c2c148","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/registration.vue
// module id = q1XF
// module chunks = 1